// 点
import { createAnyCircle } from "../threeObject/index";
import mxcad from "mxcad";
const { McDbCircle, McCmColor } = mxcad;
import store from "@/store";

class rlCircleData {
  constructor() {
    // 顶点列表
    this.ptCenter = null; //圆心
    this.Radius = 20; //半径
    this.mcDbId = null;
    this.McDbCircle = null; //new McDbCircle();
    this.classTypeName = "rlCircle";
    this.m_groupName = "rlCircleGroup";
  }

  // 绘制
  // worldDraw(pWorldDraw) {
  //   let wPointObj = createAnyCircle(this.points, this.radiusSize);
  //   pWorldDraw.drawEntity(wPointObj);
  // }
  draw(visible) {
    this.McDbCircle = new McDbCircle(
      this.ptCenter.x,
      this.ptCenter.y,
      this.ptCenter.z,
      store.state.platBtns.fontSize
    );
    this.McDbCircle.trueColor = new McCmColor(255, 0, 255);
    this.McDbCircle.visible = visible;
    // this.McDbCircle.center = this.ptCenter;
    // this.McDbCircle.radius = this.Radius;
    this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.McDbCircle);
  }

  //删除
  erase() {
    this.mcDbId?.getMcDbEntity().erase();
  }
}

export { rlCircleData };
